import localForage from "localforage";

class GenericPersistence {
  constructor(resourceName) {
    this.mDb = localForage.createInstance({ name: this._resourceName });
  }

  async getInstance() {
    return this;
  }

  async store(resource) {
    const existingResourceResult = await this.get(resource.uuid);
    const currentRes = existingResourceResult.success
      ? existingResourceResult.data
      : {};
    const newResource = { ...currentRes, ...resource };

    try {
      await this.mDb.setItem(resource.uuid, newResource);
      return true;
    } catch (e) {
      console.error(e);
      return false;
    }
  }

  async get(uuid) {
    try {
      const doc = await this.mDb.getItem(uuid);

      if (!doc) {
        return { success: false };
      }

      return { success: true, data: doc };
    } catch (e) {
      console.error(e);
      return { success: false };
    }
  }
}

export default GenericPersistence;



// WEBPACK FOOTER //
// ./src/core/data/persistence/generic.persistence.js